export default "__VITE_ASSET__D3tYKVY7__"